import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Modal } from "antd";
import { WarningOutlined } from "@ant-design/icons";
import moment from "moment";
import db from "../database";

const TillModalHandler = () => {
  const [showTillModal, setShowTillModal] = useState(false);
  const history = useHistory();

  useEffect(() => {
    const checkTillEvents = async () => {
      try {
        const tillEvents = await db?.tillEvents.where("tillStatus").equals("open").toArray();
        if (tillEvents?.length > 0) {
          const currentDate = moment().format("YYYY-MM-DD");
          const tillEventDate = tillEvents[0]?.openingTime?.split(" ")[0];
          if (currentDate !== tillEventDate) {
            const currentPath = window.location.pathname;
            const excludedPaths = ["/close-till", "/close-till-all", "/cash-to-keep", "/sign-in"];
            const isExcluded = excludedPaths.some((path) => currentPath.includes(path));
            if (!isExcluded) setShowTillModal(true);
          }
        }
      } catch (err) {
        console.error("Till event check failed:", err);
      }
    };

    checkTillEvents();
    const interval = setInterval(checkTillEvents, 1000);
    return () => clearInterval(interval);
  }, []);

  const handleOk = () => {
    setShowTillModal(false);
    const posConfig = JSON.parse(localStorage.getItem("posConfig"));
    if (posConfig?.shiftClose) {
      if (posConfig?.showDenominations === "Y") {
        history.push("/close-till");
      } else if (posConfig?.showDenominations === "N") {
        history.push("/close-till-all");
      }
    } else {
      history.push("/");
    }
  };

  return (
    <Modal visible={showTillModal} footer={null} closable={false} maskClosable={false} width={450} centered bodyStyle={{ padding: "32px", borderRadius: "35px" }}>
      <div style={{ display: "flex", justifyContent: "center", marginBottom: "24px" }}>
        <div
          style={{
            width: "48px",
            height: "48px",
            backgroundColor: "#FEE4E2",
            borderRadius: "999px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <WarningOutlined style={{ color: "#D92D20", fontSize: "20px" }} />
        </div>
      </div>
      <h2 style={{ fontSize: "18px", fontWeight: 600, color: "#101828", marginBottom: "12px" }}>Till Closure Required</h2>
      <p style={{ fontSize: "14px", color: "#475467", marginBottom: "24px" }}>You have a pending Till session from a previous day. Please close the Till before continuing.</p>
      <div
        style={{
          backgroundColor: "#F9FAFB",
          borderRadius: "8px",
          padding: "12px 16px",
          fontSize: "11px",
          color: "#475467",
          marginBottom: "24px",
          textAlign: "center",
        }}
      >
        Click <strong>"Okay"</strong> to proceed to the Close Till page.
      </div>
      <div style={{ textAlign: "right" }}>
        <button
          onClick={handleOk}
          style={{
            backgroundColor: "#2970FF",
            border: "none",
            color: "#FFFFFF",
            padding: "8px 16px",
            fontSize: "14px",
            borderRadius: "8px",
            cursor: "pointer",
          }}
        >
          Okay
        </button>
      </div>
    </Modal>
  );
};

export default TillModalHandler;
